// 新聞頁面 - 側邊熱門新聞
'use client';

import React from 'react';
import { useParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';

import TopNewsComponent from './TopNewsComponent'; // 熱門新聞元件

const TopNewsWrapper = ({ topNews }) => {
    const params = useParams();
    const { category } = params;
    const { t } = useTranslation();
    const categoryTitle =
        category === 'term' || category === 'news' ? 'HOT' : category?.toUpperCase();

    return (
        <div className="rounded-[8px] border-black9 border-1 p-[20px] space-y-[12px] mb-[12px]">
            <h3 className="text-bd2b text-white">{t(`TITLE_${categoryTitle}`)} TOP NEWS</h3>

            <div className="space-y-[16px]">
                {topNews?.map((item, i) => (
                    <React.Fragment key={`top-news-list-${i}`}>
                        {i === 0 ? '' : <hr className="w-full border-black7 border-opacity-[.5]" />}
                        <TopNewsComponent info={item} />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default TopNewsWrapper;
